var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12545 2.9444L1.12814 4.89423L0 3.82873L3.99852 0L8 3.8362L6.9209 4.87556L4.91479 2.92012L4.8353 2.94998C4.82844 3.04804 4.81668 3.1461 4.81668 3.24508C4.81668 5.06139 4.81668 6.8777 4.81668 8.69401C4.81668 8.92279 4.76076 9.01337 4.50668 8.99842C4.16328 8.97975 3.81905 8.97975 3.47566 8.99842C3.23728 9.01056 3.18137 8.92654 3.18137 8.70803C3.18922 6.90105 3.18137 5.09408 3.18137 3.28618V2.96959L3.12545 2.9444Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowUp);
export default __webpack_public_path__ + "static/media/sort-arrow-up.dce3b54e8550b13d3bb015683b91836f.svg";
export { ForwardRef as ReactComponent };